module.exports = global["Tether"] = require("-!c:\\OpenServer\\domains\\localhost\\prestapro\\ps17\\singlewave\\themes\\singlewave\\_dev\\node_modules\\babel-loader\\lib\\index.js??ref--0!.\\tether.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?Tether!./node_modules/tether/dist/js/tether.js
// module id = 8
// module chunks = 0